import React, { useCallback, useEffect, useState } from "react";
import api from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import ConfirmDialog from "../components/ConfirmDialog";
import { BranchAdmin } from "./SubeMerkezi";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../components/ui/dialog";
import { Building2, Plus, Trash2, LogIn, Power, Users as UsersIcon, Database, KeyRound, Pencil, Settings2 } from "lucide-react";
import { toast } from "sonner";
import { trUpper } from "../lib/mw";
import PartnershipsPanel from "../components/PartnershipsPanel";
import PartnerGroupsPanel from "../components/PartnerGroupsPanel";


export default function Firms() {
  const { setTenant } = useAuth();
  const [firms, setFirms] = useState([]);
  const [form, setForm] = useState({ name: "", admin_username: "", admin_password: "", admin_name: "" });
  const [confirm, setConfirm] = useState(null);
  const [brFirm, setBrFirm] = useState(null);
  const [brList, setBrList] = useState([]);
  const loadBr = (f) => api.get("/org/branches", { params: { firm: f.id } }).then((r) => setBrList(r.data)).catch(() => setBrList([]));
  const openBr = (f) => { setBrFirm(f); loadBr(f); };

  const load = useCallback(() => { api.get("/firms").then((r) => setFirms(r.data)); }, []);
  useEffect(() => { load(); }, [load]);

  const create = async () => {
    if (!form.name || !form.admin_password || !form.admin_username) {
      toast.error("FİRMA ADI, YÖNETİCİ KULLANICI ADI VE ŞİFRE GEREKLİ"); return;
    }
    try {
      await api.post("/firms", form);
      toast.success("FİRMA OLUŞTURULDU");
      setForm({ name: "", admin_username: "", admin_password: "", admin_name: "" });
      load();
    } catch (e) { toast.error(e.response?.data?.detail || "HATA"); }
  };

  const openFirm = (id) => { localStorage.setItem("mwcrm_tenant", id); window.location.href = `/firmalar/${id}`; };
  const toggleActive = async (f) => { await api.put(`/firms/${f.id}`, { active: !f.active }); load(); };
  const rename = async (f) => {
    const name = window.prompt("YENİ FİRMA ADI", f.name);
    if (name === null) return;
    const v = name.trim();
    if (!v) { toast.error("FİRMA ADI BOŞ OLAMAZ"); return; }
    try { await api.put(`/firms/${f.id}`, { name: v }); toast.success("FİRMA ADI GÜNCELLENDİ"); load(); }
    catch (e) { toast.error(e.response?.data?.detail || "HATA"); }
  };
  const del = async () => { await api.delete(`/firms/${confirm.id}`); toast.success("FİRMA SİLİNDİ"); setConfirm(null); load(); };

  return (
    <div className="mw-fade-up space-y-5" data-testid="firms-page">
      <div>
        <h1 className="font-head text-3xl font-bold tracking-tight text-white flex items-center gap-2">
          <Building2 className="h-7 w-7 text-blue-400" /> FİRMA YÖNETİMİ
        </h1>
        <p className="text-sm text-slate-400">SİSTEMİ KULLANAN FİRMALARI OLUŞTURUN. HER FİRMA KENDİ VERİSİNİ GÖRÜR, DİĞERLERİNİNKİNİ GÖREMEZ.</p>
      </div>

      <div className="rounded-xl border border-slate-800 bg-slate-900 p-4">
        <p className="mb-3 text-sm font-semibold text-slate-300">YENİ FİRMA + FİRMA YÖNETİCİSİ</p>
        <div className="grid grid-cols-1 gap-3 sm:grid-cols-5">
          <Input data-testid="firm-name" placeholder="FİRMA ADI" value={form.name} onChange={(e) => setForm((f) => ({ ...f, name: trUpper(e.target.value) }))} className="h-10 border-slate-700 bg-slate-800 text-slate-100 sm:col-span-2" />
          <Input data-testid="firm-admin-username" placeholder="YÖNETİCİ KULLANICI ADI" value={form.admin_username} onChange={(e) => setForm((f) => ({ ...f, admin_username: e.target.value }))} className="h-10 border-slate-700 bg-slate-800 text-slate-100" />
          <Input data-testid="firm-admin-password" type="password" placeholder="YÖNETİCİ ŞİFRE" value={form.admin_password} onChange={(e) => setForm((f) => ({ ...f, admin_password: e.target.value }))} className="h-10 border-slate-700 bg-slate-800 text-slate-100" />
          <Button data-testid="create-firm-button" onClick={create} className="h-10 bg-blue-600 text-white hover:bg-blue-700"><Plus className="mr-1 h-4 w-4" /> OLUŞTUR</Button>
        </div>
      </div>

      <div className="overflow-hidden rounded-xl border border-slate-800 bg-slate-900">
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b border-slate-800 bg-slate-800/50 text-left text-xs uppercase tracking-wider text-slate-400">
              <th className="px-4 py-3">FİRMA</th><th className="px-4 py-3">DURUM</th>
              <th className="px-4 py-3">KULLANICI</th><th className="px-4 py-3">MÜŞTERİ</th>
              <th className="px-4 py-3">PIN</th><th className="px-4 py-3 text-right">İŞLEM</th>
            </tr>
          </thead>
          <tbody>
            {firms.length === 0 && <tr><td colSpan={6} className="px-4 py-10 text-center text-slate-500">HENÜZ FİRMA YOK</td></tr>}
            {firms.filter((f) => !f.parent_id).map((f) => (
              <tr key={f.id} data-testid={`firm-row-${f.id}`} onDoubleClick={() => openFirm(f.id)} className="cursor-pointer border-b border-slate-800/60 hover:bg-slate-800/40">
                <td className="px-4 py-3"><button data-testid={`open-firm-${f.id}`} onClick={() => openFirm(f.id)} className="font-semibold text-slate-100 hover:text-blue-300 hover:underline">{f.name}</button>
                  {firms.some((x) => x.parent_id === f.id) && <div className="mt-0.5 text-[10px] text-slate-500">ŞUBELER: {firms.filter((x) => x.parent_id === f.id).map((x) => x.name + (x.closed ? " (KAPALI)" : "")).join(", ")}</div>}</td>
                <td className="px-4 py-3">
                  <span className={`rounded-full px-2 py-0.5 text-xs font-semibold ${f.active ? "bg-emerald-500/20 text-emerald-300" : "bg-rose-500/20 text-rose-300"}`}>{f.active ? "AKTİF" : "PASİF"}</span>
                </td>
                <td className="px-4 py-3 text-slate-300"><UsersIcon className="mr-1 inline h-3.5 w-3.5 text-slate-500" />{f.user_count}</td>
                <td className="px-4 py-3 text-slate-300"><Database className="mr-1 inline h-3.5 w-3.5 text-slate-500" />{f.customer_count}</td>
                <td className="px-4 py-3">{f.has_pin ? <KeyRound className="h-4 w-4 text-amber-400" /> : <span className="text-slate-600">—</span>}</td>
                <td className="px-4 py-3">
                  <div className="flex items-center justify-end gap-1">
                    <Button data-testid={`manage-firm-${f.id}`} size="sm" onClick={() => openFirm(f.id)} className="bg-emerald-600 text-white hover:bg-emerald-700"><Settings2 className="mr-1 h-4 w-4" /> YÖNET</Button>
                    <Button data-testid={`branches-firm-${f.id}`} size="sm" onClick={() => openBr(f)} className="bg-sky-700 text-white hover:bg-sky-800"><Building2 className="mr-1 h-4 w-4" /> ŞUBELER</Button>
                    <Button data-testid={`enter-firm-${f.id}`} size="sm" onClick={() => setTenant(f.id)} className="bg-blue-600 text-white hover:bg-blue-700"><LogIn className="mr-1 h-4 w-4" /> SEÇ &amp; GİR</Button>
                    <button data-testid={`rename-firm-${f.id}`} onClick={() => rename(f)} title="FİRMA ADINI DEĞİŞTİR" className="rounded-md p-1.5 text-slate-400 hover:bg-slate-700 hover:text-blue-400"><Pencil className="h-4 w-4" /></button>
                    <button data-testid={`toggle-firm-${f.id}`} onClick={() => toggleActive(f)} title="AKTİF/PASİF" className="rounded-md p-1.5 text-slate-400 hover:bg-slate-700 hover:text-amber-400"><Power className="h-4 w-4" /></button>
                    {f.id !== "demo" && (
                      <button data-testid={`delete-firm-${f.id}`} onClick={() => setConfirm(f)} title="SİL" className="rounded-md p-1.5 text-slate-400 hover:bg-slate-700 hover:text-rose-400"><Trash2 className="h-4 w-4" /></button>
                    )}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <Dialog open={!!brFirm} onOpenChange={(o) => !o && setBrFirm(null)}>
        <DialogContent className="max-w-6xl border-slate-700 bg-slate-900 text-slate-100">
          <DialogHeader><DialogTitle>{brFirm?.name} — ŞUBE EKLE / YÖNET</DialogTitle></DialogHeader>
          {brFirm && <BranchAdmin firm={brFirm.id} branches={brList} reload={() => { loadBr(brFirm); load(); }} />}
        </DialogContent>
      </Dialog>

      <PartnerGroupsPanel firms={firms} />
      <PartnershipsPanel firms={firms} />

      <ConfirmDialog
        open={!!confirm}
        onOpenChange={(v) => !v && setConfirm(null)}
        title="FİRMA SİLİNECEK"
        description={`${confirm?.name || ""} firması ve TÜM verileri (müşteri, kargo, kullanıcı, log) kalıcı olarak silinecek. Bu işlem geri alınamaz.`}
        onConfirm={del}
      />
    </div>
  );
}
